import { IDataProviderSort } from 'core-components/types'

const compareValues = <T>(
  a: T,
  b: T,
  currentSortData: IDataProviderSort,
  currentRulesIndex: number,
  allSortsData: IDataProviderSort[]
): number => {
  if (a[currentSortData.field] === b[currentSortData.field]) {
    const newComparator = allSortsData[currentRulesIndex + 1]
    if (newComparator) {
      return compareValues(a, b, newComparator, currentRulesIndex + 1, allSortsData)
    }
    return 0
  }
  const correctSortResult = currentSortData.dir === 'asc' ? 1 : -1
  return a[currentSortData.field] > b[currentSortData.field]
    ? correctSortResult
    : correctSortResult * -1
}

export const sortData = <T>(
  newData: T[],
  sort: IDataProviderSort | IDataProviderSort[] | undefined
) => {
  const items = [...newData]
  if (!sort || (Array.isArray(sort) && !sort.length)) {
    return items
  }
  if (!Array.isArray(sort)) {
    items.sort((a, b) => compareValues(a, b, sort, 0, [sort]))
    return items
  }
  const startSortData = sort[0]
  items.sort((a, b) => compareValues(a, b, startSortData, 0, sort))
  return items
}
